import {get} from "lodash";
import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";

function TableItem({header, row}) {
    const value = useMemo(() => {
        const {field, valueFormatter} = header;
        let value = JSON.parse(JSON.stringify(row));
        if (field) {
            value = get(row, field, "");
        }
        if (valueFormatter) {
            value = valueFormatter(value);
        }
        return value;
    }, [header, row]);

    // klasa komórki z nagłówka (np. kolumny poziomów grupowania)
    const className = header.cellClassName;

    if (header.component) {
        if (typeof header.component === "function") {
            return (
                <td className={className}>
                    {header.component({
                        value,
                        field: header.field,
                        object: row,
                    })}
                </td>
            );
        } else {
            return (
                <td className={className}>
                    {React.cloneElement(header.component, {
                        // index,
                        value,
                        // page,
                        // paginationItems,
                        object: row,
                        field: header.field,
                    })}
                </td>
            );
        }
    }
    return <td className={className}>{value}</td>;
}

export function TableRow({
    headers,
    row,
    shouldIndex,
    rowIndex,
    className,
    style,
    indexPosition = 0,
}) {
    // indeks stoi przed `indexPosition`-tą kolumną (w trybie grupowania za kolumnami poziomów)
    const indexCell = shouldIndex && <td key="index">{rowIndex + 1}</td>;
    return (
        <tr className={className} style={style}>
            {headers.map((header, index) => (
                <React.Fragment key={index}>
                    {index === indexPosition && indexCell}
                    <TableItem header={header} row={row} />
                </React.Fragment>
            ))}
        </tr>
    );
}

function EmptyTable({headersAmount}) {
    const {t} = useTranslation();

    return (
        <tr>
            <td colSpan={headersAmount}>
                <div className="empty-table">
                    <i className="fa-solid fa-magnifying-glass" />
                    <h4>{t("noData")}</h4>
                    <small>{t("cannotFindDataToDisplay")}</small>
                </div>
            </td>
        </tr>
    );
}

export default function AsyncTableBody({rows, headers, shouldIndex, offset}) {
    return (
        <tbody>
            {rows.length === 0 && (
                <EmptyTable headersAmount={headers.length + 1} />
            )}
            {rows.map((row, index) => (
                <TableRow
                    headers={headers}
                    row={row}
                    key={index}
                    shouldIndex={shouldIndex}
                    rowIndex={offset + index}
                />
            ))}
        </tbody>
    );
}
